export const DOMINOS_SLIDES = [
    {
        id: "intro",
        eyebrow: "Dominos.js",
        title: "Dominoes can be viewed as a graph.",
        body:
            "A domino tile is not just a game piece. It can also be treated as a connection between two values.\n\nThat turns a familiar tabletop game into a graph problem with structure, rules, and traversal.",
        footerNote: "The storyboard will move from physical tiles to graph edges.",
        topRightBlurb: {
            eyebrow: "Visual Mapping",
            title: "[2|5] -> edge(2, 5)",
            body:
                "Every tile connects two pip values.\nA double like [4|4] becomes a self-loop.",
        },
        controlHint: {
            title: "Advance slide-by-slide",
            body:
                "Each continue action triggers camera and object transitions instead of a hard scene cut.",
        },
        sceneState: {
            cameraPosition: [0, 3.2, 10.5],
            cameraTarget: [0, 1.2, 0],
            layout: "fan",
            emphasizeGraph: 0,
        },
    },
    {
        id: "tile-to-edge",
        eyebrow: "Mapping",
        title: "Each tile becomes an edge between vertices.",
        body:
            "If the tile is [2|5], it connects vertex 2 to vertex 5.\n\nThe physical domino and the abstract graph are two views of the same relationship.",
        footerNote: "This is the core conceptual bridge.",
        topRightBlurb: {
            eyebrow: "Graph Terms",
            title: "vertex, edge, loop",
            body:
                "Pip values become vertices.\nTiles become edges.\nDoubles become loops.",
        },
        sceneState: {
            cameraPosition: [0, 2.6, 8.2],
            cameraTarget: [0, 1.1, 0],
            layout: "bridge",
            emphasizeGraph: 0.45,
        },
    },
    {
        id: "multigraph",
        eyebrow: "Structure",
        title: "A domino set behaves like a multigraph.",
        body:
            "A full set contains many edges, including loops.\n\nThe graph is not just decorative. It can be analyzed for connectivity, degree, and traversability.",
        footerNote: "Next: why chaining tiles matches Euler traversal.",
        topRightBlurb: {
            eyebrow: "Observation",
            title: "Domino chaining is edge usage.",
            body:
                "Using each tile once is the same as using each edge once.",
        },
        sceneState: {
            cameraPosition: [0, 4.6, 7.8],
            cameraTarget: [0, 1.9, 0],
            layout: "graph-grid",
            emphasizeGraph: 0.85,
        },
    },
    {
        id: "euler",
        eyebrow: "Traversal",
        title: "A valid full domino chain is an Euler path.",
        body:
            "If a player can lay every tile exactly once in a legal chain, the graph has an Euler path.\n\nIf the chain closes back on itself, it is an Euler circuit.",
        footerNote: "This is where graph theory explains gameplay.",
        topRightBlurb: {
            eyebrow: "Rule",
            title: "Odd-degree counts matter.",
            body:
                "0 odd vertices -> Euler circuit\n2 odd vertices -> Euler path\nMore than 2 -> impossible",
        },
        sceneState: {
            cameraPosition: [0, 3.0, 7.2],
            cameraTarget: [0, 1.3, 0],
            layout: "path-demo",
            emphasizeGraph: 1,
        },
    },
    {
        id: "game-mode-intro",
        eyebrow: "Application",
        title: "Now turn the concept into a playable system.",
        body:
            "After the storyboard, the viewer can enter a simplified domino game against an AI.\n\nThe same visual language can keep explaining the graph underneath the move selection.",
        footerNote: "The next phase can reuse the same stage shell and scene runtime.",
        topRightBlurb: {
            eyebrow: "Next Phase",
            title: "Story mode -> game mode",
            body:
                "The scene scaffolding stays. Only the mode, controls, and state machine expand.",
        },
        sceneState: {
            cameraPosition: [0, 3.4, 9.2],
            cameraTarget: [0, 1.5, 0],
            layout: "tableau",
            emphasizeGraph: 0.7,
        },
    },
];